import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Dialog from '@material-ui/core/Dialog';
import IconButton from '@material-ui/core/IconButton';
import { withStyles } from '@material-ui/core/styles';

import AllHoldCardsTable from '../shared';
import xIcon from '../../../../../core/assets/svg/x.svg';
import styles from '../hold-cards.styles';
import Body from './body';
import ListHeader from './header';

const ModalBody = ({ allActiveHoldCards, classes, onPageChange, count, page, onClose, state }) => {
  return (
    <>
      <div className={classes.dialogHeader}>
        <IconButton className={classes.dialogCloseButton} onClick={onClose}>
          <img src={xIcon} alt="Close" className={classes.dialogCloseButtonIcon} />
        </IconButton>
      </div>
      <div className={classes.dialogTitleContainer}>
        <div className={classes.dialogTitle}>Hold Cards</div>
      </div>
      <AllHoldCardsTable
        state={state}
        allActiveHoldCards={allActiveHoldCards}
        classes={{ table: classes.bigTable }}
        body={Body}
        header={ListHeader}
        onPageChange={onPageChange}
        count={count}
        page={page}
      />
    </>
  );
};

ModalBody.propTypes = {
  allActiveHoldCards: PropTypes.array.isRequired,
  classes: PropTypes.object.isRequired,
  onPageChange: PropTypes.func.isRequired,
  count: PropTypes.number.isRequired,
  page: PropTypes.number.isRequired,
  onClose: PropTypes.func.isRequired,
  state: PropTypes.string.isRequired
};

class Modal extends Component {
  static propTypes = {
    allActiveHoldCards: PropTypes.array.isRequired,
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    classes: PropTypes.object.isRequired,
    state: PropTypes.string.isRequired
  };

  constructor(props) {
    super(props);
    this.state = { page: 0 };
  }

  onPageChange = (e, page) => {
    this.setState({
      page
    });
  };

  render() {
    const { allActiveHoldCards, open, onClose, classes, state } = this.props;
    const { page } = this.state;
    return (
      <Dialog
        open={open}
        onClose={onClose}
        classes={{
          root: classes.dialogRoot,
          container: classes.backdrop,
          paper: classes.dialogPaper,
          scrollPaper: classes.scrollPaper
        }}
      >
        {open && (
          <ModalBody
            state={state}
            allActiveHoldCards={allActiveHoldCards.slice(page * 5, page * 5 + 5)}
            classes={classes}
            onPageChange={this.onPageChange}
            count={allActiveHoldCards.length}
            page={page}
            onClose={onClose}
          />
        )}
      </Dialog>
    );
  }
}

export default withStyles(styles)(Modal);
